import { Link } from "react-router-dom";
import { ChevronRight, LogOut } from "lucide-react";

import { useAuth } from "@/auth/useAuth";
import { Button } from "@/components/Button";
import { Card, CardBody } from "@/components/Card";
import { PageHeader } from "@/layout/PageHeader";
import { Page } from "@/layout/Page";
import { AIStatusPanel } from "@/features/ingestion/AIStatusPanel";
import { NAV_ITEMS } from "@/layout/navigation";

/** The mobile "Plus" screen: everything the bottom bar cannot hold. */
export function MorePage() {
  const { user, logout } = useAuth();
  const items = NAV_ITEMS.filter(
    (item) => !["/dashboard", "/inventory"].includes(item.to),
  );

  return (
    <Page width="reading">
      <PageHeader title="Plus" subtitle={user ? `${user.display_name} · ${user.role}` : undefined} />
      <Card>
        <ul className="divide-y divide-border/60">
          {items.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="flex items-center gap-3 px-4 py-3 active:bg-surface-hover"
              >
                <item.icon className="size-5 shrink-0 text-ink-subtle" aria-hidden />
                <span className="flex-1 text-[14px] text-ink">{item.label}</span>
                {item.comingSoon && (
                  <span className="rounded border border-border px-1.5 py-0.5 text-[10px] uppercase text-ink-subtle">
                    {item.comingSoon}
                  </span>
                )}
                <ChevronRight className="size-4 shrink-0 text-ink-subtle" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
        <CardBody>
          <Button variant="secondary" fullWidth onClick={logout}>
            <LogOut className="size-4" aria-hidden />
            Se déconnecter
          </Button>
        </CardBody>
      </Card>

      {/* Kept here rather than on the dashboard: an operator needs it when
          something looks wrong, not every morning. */}
      <AIStatusPanel />
    </Page>
  );
}
